import React from 'react'
import PropTypes from 'prop-types'
import ErrorMessage from 'components/share/ErrorMessage'
import { Trans } from 'react-i18next'
import openHelpPage from '../../../utils/helpLinkUtil'
import StyledButton from '../LinkButton'

const PlaceHolder = ({ children }) => (
  <ErrorMessage>
    {children || (
      <span aria-label="work in progress" role="img">
        <Trans i18nKey="thisWidgetIsComingSoon">
          <StyledButton onClick={() => openHelpPage(8179232)} />
        </Trans>
      </span>
    )}
  </ErrorMessage>
)

PlaceHolder.defaultProps = {
  children: null
}

PlaceHolder.propTypes = {
  children: PropTypes.node
}

export default PlaceHolder
